var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns columns--full is-vcentered"},[_c('div',{staticClass:"column has-text-centered onboarding-create-site__description"},[_c('transition',{attrs:{"appear":"","name":"slide-fade","mode":"in-out"}},[_c('h1',{staticClass:"onboarding-create-site__title"},[_vm._v(" Estamos finalizando os últimos detalhes ")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }